import { render, staticRenderFns } from "./no-audit-roles.vue?vue&type=template&id=9d4d97a0&scoped=true"
import script from "./no-audit-roles.vue?vue&type=script&lang=js"
export * from "./no-audit-roles.vue?vue&type=script&lang=js"
import style0 from "./no-audit-roles.vue?vue&type=style&index=0&id=9d4d97a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4d97a0",
  null
  
)

export default component.exports